// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"CompanyForm_fullWidth__2jxBP","formItem":"CompanyForm_formItem__2CDUw"};